module.exports = __webpack_public_path__ + "media/images/success-948a5d6cd5bc6a89aa2b7292eb9a8d57.mp3";